export const IDENTITY_KEY = "/api/auth/me";
